import { ApiClientError } from '../services/api';

/**
 * Extracts a user-friendly error message from any error type
 */
export function getErrorMessage(error: unknown, fallback?: string): string {
  if (error instanceof ApiClientError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallback ?? 'Something went wrong. Please try again.';
}

/**
 * Extracts field-level validation errors from an API error
 */
export function getFieldErrors(error: unknown): Record<string, string> {
  if (error instanceof ApiClientError && error.fieldErrors) {
    return Object.fromEntries(
      error.fieldErrors.map((fe) => [fe.field, fe.message])
    );
  }
  return {};
}

/**
 * Checks if an error has field-level validation errors
 */
export function hasFieldErrors(error: unknown): boolean {
  return (
    error instanceof ApiClientError &&
    !!error.fieldErrors &&
    error.fieldErrors.length > 0
  );
}
